<template>
    <div class="footer-container">
        <div class="footer-container-left">
            <div class="middle-container">
                <div v-if="secondPartLists.length" class="second-part">
                    <div class="flex-container">
                        <div
                            v-for="(item, index) in secondPartLists"
                            :key="index"
                            class="flex-item"
                            v-on:click="openLink(item.address)"
                        >
                            {{ item.name }}
                        </div>
                    </div>
                </div>
                <div v-if="options.length > 0" class="select-container">
                    <el-select v-model="selValue" placeholder="友情链接" v-on:change="changeSelect">
                        <el-option
                            v-for="item in options"
                            :key="item.name"
                            :label="item.name"
                            :value="item"
                        ></el-option>
                    </el-select>
                </div>
            </div>

            <div class="bottom-part">
                <span class="bottom-text">
                    {{ $cache.getCompanyInfoParam("10101012") }}&nbsp; &nbsp;
                    {{ $cache.getCompanyInfoParam("10101011") }}&nbsp; &nbsp;
                </span>
            </div>
        </div>
        <div
            v-if="$cache.getCompanyInfoParam('10106001') || $cache.getCompanyInfoParam('10107001')"
            class="qrcode-container"
        >
            <div v-if="$cache.getCompanyInfoParam('10106001')" class="img-box">
                <div class="img-title">
                    <div class="title-text">官方APP</div>
                </div>
                <img
                    class="code-img"
                    :src="
                        $util.imgSrc({
                            fileCode: $cache.getCompanyInfoParam('10106001')
                        })
                    "
                    alt=""
                    srcset=""
                />
            </div>
            <div v-if="$cache.getCompanyInfoParam('10107001')" class="img-box">
                <div class="img-title">
                    <div class="title-text">微信服务号</div>
                </div>
                <img
                    class="code-img"
                    :src="
                        $util.imgSrc({
                            fileCode: $cache.getCompanyInfoParam('10107001')
                        })
                    "
                    alt=""
                    srcset=""
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            secondPartLists: [],
            options: [],
            selValue: ""
        };
    },
    mounted() {
        const list = JSON.parse(this.$cache.getCompanyInfoParam("10105003"));
        this.secondPartLists = list;
        this.options = JSON.parse(this.$cache.getCompanyInfoParam("10105004")) || [];
    },
    methods: {
        openLink(url) {
            window.open(url, "_blank");
        },
        changeSelect(val) {
            this.openLink(val.address);
            this.selValue = "";
        }
    }
};
</script>

<style lang="scss" scoped>
.footer-container {
    width: 100vw;
    background: #404040;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 30px;
    z-index: 100;
    box-sizing: border-box;

    .qrcode-container {
        display: flex;
        gap: 24px;
        margin-left: 76px;
        .img-box {
            width: 66px;
            height: 85px;
            border-radius: 4px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            padding: 6px 5px;
            background: #fff;
            .img-title {
                display: flex;
                align-items: center;
                margin-bottom: 6px;

                .title-text {
                    font-weight: 500;
                    font-size: 10px;
                    color: #999999;
                }
            }
            .code-img {
                width: 56px;
                height: 56px;
                display: inline-block;
                align-self: center;
            }
        }
    }
    .middle-container {
        max-width: 1200px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        padding: 0 13px;
        padding-bottom: 20px;
        border-bottom: 2px solid #979797;
        .select-container {
            ::v-deep .el-select {
                background: #404040;
            }
            ::v-deep .el-input {
                background: #404040;
            }
            ::v-deep .el-input__inner {
                background: #404040;
                border-radius: 8px;
            }
            ::v-deep .el-input__suffix {
                // height: 30px !important;
            }
            ::v-deep .el-select .el-input.is-focus .el-input__inner {
                background: #404040 !important;
                border-color: #ffffff !important;
            }
            ::v-deep .el-select .el-input__inner:focus {
                border-color: #ffffff !important;
            }
        }
    }
    .second-part {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        .flex-container {
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .flex-item {
            height: 16px;
            line-height: 16px;
            text-align: center;
            border-left: 1px solid #cccccc;
            border-right: 1px solid #cccccc;
            color: #cccccc;
            font-size: 16px;
            padding: 0 20px;
            cursor: pointer;
            white-space: nowrap;
            &:hover {
                color: #fff;
            }
            &:first-of-type {
                border-left: 0px;
            }
            &:last-of-type {
                border-right: 0px;
            }
        }
        .flex-item:first-child {
            padding-left: 0;
        }

        .flex-item:nth-last-child(1) {
            border-right: none;
        }
    }

    .bottom-part {
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #cccccc;
        &:hover {
            color: #fff;
        }
    }
    .footer-container-left {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
    }
}
</style>
